import React, { useEffect, useState } from 'react';

import { Button, Tooltip } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

import BotSettingsModal from '../BotSettingsModal/BotSettingsModal';

import { isDevelopmentMode } from '@/utils/domainValidation';

import { useBotId } from '@/hooks/useBotId';

import styles from './BotSettingsButton.module.scss';

const BotSettingsButton = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const botId = useBotId();

  useEffect(() => {
    // Проверяем домен
    if (isDevelopmentMode()) {
      setShowButton(true);
    }
  }, []);

  const handleOpenModal = () => {
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  if (!showButton) {
    return null;
  }

  return (
    <>
      <div className={styles.botSettingsButton}>
        <Tooltip title='Настройки чат-бота' placement='top'>
          <Button
            type='primary'
            shape='circle'
            size='large'
            icon={<SettingOutlined />}
            onClick={handleOpenModal}
            className={styles.settingsBtn}
          />
        </Tooltip>
      </div>

      <BotSettingsModal
        open={modalVisible}
        onCancel={handleCloseModal}
        botId={botId} // fallback botId
      />
    </>
  );
};

export default BotSettingsButton;
